/* src/app/hire-person-search/hire-candidate-slider/hire-slider-experience-view/hire-slider-experience-view.component.scss */
.clogo {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid rgba(48, 5, 127, 0.04);
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: #999;
  overflow: auto;
}
.clogo img {
  width: 100%;
  height: auto;
}
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.companyHover {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: #969696;
}
div em {
  background-color: #FCE3A1 !important;
  font-style: normal !important;
}
.exp-list ul {
  padding-left: 15px;
  margin-bottom: 0;
}
/*# sourceMappingURL=hire-slider-experience-view.component-P44OPLHY.css.map */
